import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "latest-transactions-carousel mb-4 mr-n2" }
const _hoisted_3 = { class: "d-flex ga-1" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex ga-1"
}
const _hoisted_5 = { class: "opacity-60" }
const _hoisted_6 = ["textContent"]

import "vue3-carousel/dist/carousel.css";
// https://ismail9k.github.io/vue3-carousel/examples.html
import { Carousel, Slide } from "vue3-carousel";

import { useRoute } from "vue-router";
import { onMounted } from "vue";

import {
  TX_FUNCTIONS,
  ROUTE_TOKEN_DETAILS,
  ROUTE_HOME,
} from "@/utils/constants";
import { formatAddress } from "@/utils";
import { useLatestTransactions } from "@/composables";
import { TransactionsService } from "@/api/generated";
import AddressAvatar from "@/components/Common/AddressAvatar.vue";
import TokenImage from "@/components/Tokens/TokenImage.vue";
import { Decimal } from "@/libs/decimal";


export default /*@__PURE__*/_defineComponent({
  __name: 'LatestTransactionsCarousel',
  setup(__props) {

const route = useRoute();
const { latestTransactions } = useLatestTransactions();

onMounted(() => {
  TransactionsService.listTransactions({
    limit: 10,
    includes: "token",
  }).then((response: any) => {
    latestTransactions.value = response.items;
  });
});

function getTransactionType(type: string) {
  switch (type) {
    case TX_FUNCTIONS.sell:
      return "sold";
    case TX_FUNCTIONS.buy:
      return "bought";
    case TX_FUNCTIONS.create_community:
      return "created";
    default:
      return "";
  }
}

function getTransactionColor(type: string) {
  switch (type) {
    case TX_FUNCTIONS.buy:
      return "success";
    default:
      return "white";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_fade_transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Carousel), {
            dir: "rtl",
            options: { currentPage: 0 },
            "snap-align": "start",
            autoplay: 2000,
            transition: 1000,
            breakpoints: {
            1680: { itemsToShow: 4 },
            1280: { itemsToShow: 3 },
            900: { itemsToShow: 3 },
            700: { itemsToShow: 2 },
            0: { itemsToShow: 1 },
          },
            "pause-autoplay-on-hover": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(latestTransactions), (transaction) => {
                return (_openBlock(), _createBlock(_unref(Slide), {
                  key: transaction.hash
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(TokenImage, {
                        cid: transaction.token.image_thumbnail,
                        width: 20,
                        height: 20
                      }, null, 8, ["cid"]),
                      _createVNode(_component_RouterLink, {
                        to: {
                  name: _unref(ROUTE_TOKEN_DETAILS),
                  params: { tokenName: transaction.token.symbol },
                }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(transaction.token.symbol), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      (
                  [_unref(TX_FUNCTIONS).sell, _unref(TX_FUNCTIONS).buy].includes(
                    transaction.tx_type
                  )
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _cache[1] || (_cache[1] = _createElementVNode("div", null, "of", -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass(`d-flex ga-1 text-${getTransactionColor(
                    transaction.tx_type
                  )}`)
                            }, [
                              _cache[0] || (_cache[0] = _createElementVNode("span", null, "AE", -1)),
                              _createElementVNode("span", null, _toDisplayString(_unref(Decimal).from(transaction.amount.ae).shorten()), 1)
                            ], 2)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(getTransactionType(transaction.tx_type)), 1),
                      _createVNode(_component_RouterLink, {
                        to: {
                  name: _ctx.ROUTE_ACCOUNT_DETAILS,
                  params: { address: transaction.address },
                },
                        class: "d-flex ga-1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            textContent: _toDisplayString(_unref(formatAddress)(transaction.address))
                          }, null, 8, _hoisted_6),
                          _createVNode(AddressAvatar, {
                            address: transaction.address,
                            size: 24
                          }, null, 8, ["address"])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, 
          [_unref(ROUTE_HOME), _unref(ROUTE_TOKEN_DETAILS)].includes(_unref(route).name) &&
          _unref(latestTransactions).length
        ]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})